import { RootState } from '../../../../redux/root-reducer';
import { IPaginationMeta, MODIFIER_ITEM_ACTION_TYPE, ModifierItem, ModifierItemActions } from './modifier-item-type';

export enum MODIFIER_ITEM_KEY {
  MODIFIER_ITEMS = 'MODIFIER_ITEMS',
  META = 'META',
  TOTAL_ITEMS = 'TOTAL_ITEMS',
}

export type ModifierItemState = {
  [MODIFIER_ITEM_KEY.MODIFIER_ITEMS]?: ModifierItem[];
  [MODIFIER_ITEM_KEY.META]?: IPaginationMeta;
  [MODIFIER_ITEM_KEY.TOTAL_ITEMS]?: number;
};

const initialState: ModifierItemState = {
  [MODIFIER_ITEM_KEY.MODIFIER_ITEMS]: [],
  [MODIFIER_ITEM_KEY.META]: undefined,
  [MODIFIER_ITEM_KEY.TOTAL_ITEMS]: undefined,
};

export const modifierItemReducers = (state = initialState, action: ModifierItemActions) => {
  switch (action.type) {
    case MODIFIER_ITEM_ACTION_TYPE.SET_MODIFIER_ITEM_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    default:
      return state;
  }
};

export const modifierItemStateSelector = <T extends MODIFIER_ITEM_KEY>(key: T) => (state: RootState): ModifierItemState[T] =>
  state.modifierItem[key];
